import {
  hasCareWorkspaceAccess,
  hasStandaloneBookingAccess,
} from "./productAccess";

export const ProductScope = Object.freeze({
  SHARED: "shared",
  CARE: "care",
  BOOKING: "booking",
});

function normalizeName(value) {
  return String(value || "").trim().toLowerCase();
}

export function isHealthcareBusiness(selectedBusiness) {
  const topCategoryName =
    selectedBusiness?.businessTopCategory?.name ||
    selectedBusiness?.businessCategory?.parent?.name ||
    "";
  const categoryName =
    selectedBusiness?.businessSubcategory?.name ||
    selectedBusiness?.businessCategory?.name ||
    selectedBusiness?.businessBasic?.businessCategory?.name ||
    "";

  return (
    normalizeName(topCategoryName) === "healthcare" ||
    normalizeName(categoryName) === "healthcare"
  );
}

export function getBusinessProductScopeFlags(providerUser, selectedBusiness) {
  const healthcareBusiness = isHealthcareBusiness(selectedBusiness);
  const hasCareAccess = hasCareWorkspaceAccess(providerUser, healthcareBusiness);
  const hasBooking = hasStandaloneBookingAccess(providerUser, healthcareBusiness);

  return {
    healthcareBusiness,
    hasCare: healthcareBusiness && hasCareAccess,
    hasBooking,
  };
}

export function getBusinessProductScopes(providerUser, selectedBusiness) {
  const { hasCare, hasBooking } = getBusinessProductScopeFlags(
    providerUser,
    selectedBusiness
  );
  const scopes = [ProductScope.SHARED];
  if (hasCare) scopes.push(ProductScope.CARE);
  if (hasBooking) scopes.push(ProductScope.BOOKING);
  return scopes;
}

export function isScopeVisible(scope, availableScopes) {
  return (
    scope === ProductScope.SHARED ||
    availableScopes.includes(scope)
  );
}
